import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unityDarkTokens, unityLightTokens } from '../unityTokens';

export const checkbox = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['checkbox'] => {
  if (!opts.panwRebrandStubYear) {
    return undefined;
  }

  return mode === 'light'
    ? {
        checkedColor: unityLightTokens['--components-checkbox-on-bg-default'],
        checkedHoverColor: unityLightTokens['--components-checkbox-on-bg-hover'],
        uncheckedBorderColor: unityLightTokens['--components-checkbox-off-border-default'],
        uncheckedHoverBorderColor: unityLightTokens['--components-checkbox-off-border-hover'],
        disabledColor: unityLightTokens['--text-disabled-color'],
      }
    : {
        checkedColor: unityDarkTokens['--components-checkbox-on-bg-default'],
        checkedHoverColor: unityDarkTokens['--components-checkbox-on-bg-hover'],
        uncheckedBorderColor: unityDarkTokens['--components-checkbox-off-border-default'],
        uncheckedHoverBorderColor: unityDarkTokens['--components-checkbox-off-border-hover'],
        disabledColor: unityDarkTokens['--text-disabled-color'],
      };
};
